import { useState } from 'react';
import { useSelector } from "react-redux";
import { Avatar, Modal, Button } from '@mantine/core';
import ModalMakeScreen from './ModalMakeScreen';
import intl from 'react-intl-universal';
import React from 'react';


const IdentShowScreenShot = (props:any) => {  
  const screenshots = useSelector((state: any) => state.user.identscreenshots)
  const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
  const token = useSelector((state: any) => state.user.token)
  const [openscreen, setOpenscreen] = useState(false);

  const paratoken = "&token="+token

    // Modal Screens
    const handleOpenscreen = () => {
      setOpenscreen(true);
    };
  
    const handleClosescreen = () => {
      setOpenscreen(false);
    };
 
  let screendata:any
  let avater

  screendata = screenshots.filter((obj: { userParticipantId: any }) => {
        return obj.userParticipantId === props.meetingParticipantId 
  });

  if (screendata.length >= 2){
  const displayavater = screendata.slice(0, 3);
  avater = displayavater.map((avater:any) => ( 
    <>
    <Avatar src={avater.imageSrc+paratoken} radius="xl" onClick={() => handleOpenscreen()}/>
    </>
  ));
  }

  return ( 
    <>
    {screendata.length === 1 &&
      <Avatar src={screendata[0].imageSrc+paratoken} radius="xl" onClick={() => handleOpenscreen()}/>
    }
    {screendata.length >= 2 &&
     <Avatar.Group spacing="sm">
      {avater}
      <Avatar radius="xl" > {screendata.length}</Avatar>
     </Avatar.Group>
    }

    <Modal
        title={intl.get('IDENTSHOWSCREEN_MODAL_HEAD')}
        opened={openscreen}
        onClose={handleClosescreen}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="auto"
        shadow="sm"
        centered
        >
          <ModalMakeScreen meetingParticipantId={props.meetingParticipantId} drnId={meetinginfo.drnId} />
          <hr />
          <Button fullWidth color="grey" variant="light" onClick={handleClosescreen}>{intl.get('IDENTSHOWSCREEN_MODAL_BUTTON')}</Button>  
    </Modal>


    </>
  );
}

export default IdentShowScreenShot;